export function getCurrencySymbol() {
    return new Intl.NumberFormat("EN-AU", {
        style: "currency",
        currency: "AUD",
    }).formatToParts(undefined)[0].value;
}
